export const BONUS_ITEMS_DETAIL_HIDDEN_ELEMENTS = [
    // 'addCartForm',
    'price',
    'qty',
    'viewMore',
    'btns',
];